export const SeekingDepartment = "Seeking Department";
export const SeekingBranch = "Seeking Branch";
export const SeekingClass = "Seeking Class";
export const SeekingSemester = "Seeking Semester";
export const SeekingCategory = "Seeking Category";
export const Actions = "Actions";

export const follow_up_date = "follow_up_date";
export const next_follow_up_date = "next_follow_up_date";